// tslint:disable
/**
 * Course API
 * Used for: - Manage courses - Manage course info - Manage students - Learning control 
 *
 * The version of the OpenAPI document: 2.6.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface RegistrationCreate
 */
export interface RegistrationCreate {
    /**
     * 
     * @type {string}
     * @memberof RegistrationCreate
     */
    studentId: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationCreate
     */
    courseId: string;
    /**
     * 
     * @type {string}
     * @memberof RegistrationCreate
     */
    status: RegistrationCreateStatusEnum;
    /**
     * Additional metadata
     * @type {object}
     * @memberof RegistrationCreate
     */
    metadata?: object;
}

/**
    * @export
    * @enum {string}
    */
export enum RegistrationCreateStatusEnum {
    Learning = 'learning',
    Pause = 'pause'
}



